<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom: 0;">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">添加</el-button>
        <el-button type="warning" icon="el-icon-close" size="small" @click="close()">关闭</el-button>
      </div>
      <ele-data-table ref="table" :config="table" :row-key="getRowKey" :initLoad="false" highlight-current-row>
        <template>
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column label="序号" width="60" type="index" align="center"></el-table-column>
          <el-table-column label="名称" prop="normName" align="center" />
          <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.status == 0 ? '正常' : '禁用' }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" align="center" />
          <el-table-column label="操作" align="center" width="350">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleUpdate(scope.row)">修改</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
      <!--表单弹窗-->
      <el-dialog
        :title="title"
        :visible.sync="open"
        width="400px"
        append-to-body
        :destroy-on-close="true"
        custom-class="ele-dialog-form"
        :lock-scroll="false"
        @close="reset"
      >
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="小类名称" prop="normName">
            <el-input v-model="form.normName" placeholder="请输入小类名称" maxlength="8" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm">确 定</el-button>
          <el-button @click="cancel">取 消</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
  import { saveItem, delNorm } from '@/config/ipadComputer/tag';

  export default {
    name: 'normList',
    data() {
      return {
        table: {
          // 表格配置
          url: '/classRoom/normPage',
          method: 'GET',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        getRowKey(row) {
          return row.id;
        },
        tagId: undefined,
        title: undefined,
        // 是否显示弹出层
        open: false,
        // 编辑项
        form: {},
        // 验证规则
        rules: {
          normName: [{ required: true, message: '指标小类名称不能为空', trigger: 'blur' }],
        },
      };
    },
    created() {
      const tagId = this.$route.params && this.$route.params.recId;
      this.tagId = tagId;
      if (tagId) {
        this.form.tagId = tagId;
        this.table.where.tagId = tagId;
        this.$nextTick(() => {
          this.$refs.table.reload();
        });
      }
    },
    methods: {
      // 表单重置
      reset() {
        this.form = {
          tagId: this.tagId,
          normName: undefined,
        };
        this.$refs['form'].resetFields();
      },
      // 取消按钮
      cancel() {
        this.open = false;
        this.reset();
      },
      /** 新增按钮操作 */
      handleAdd() {
        this.title = '新增指标小类';
        this.open = true;
        this.reset();
      },
      /** 修改按钮操作 */
      handleUpdate(row) {
        this.title = '修改指标小类';
        this.form = this.$util.deepClone(row);
        this.open = true;
      },
      submitForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.form) {
              if (this.form[key] !== null && this.form[key] !== undefined) {
                formData.append(key, this.form[key]);
              }
            }
            if (this.form.id != undefined) {
              saveItem(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.$message({ type: 'success', message: '修改成功' });
                  this.open = false;
                  this.$refs.table.reload();
                }
              });
            } else {
              saveItem(formData).then((res) => {
                if (res.data.resCode == 200) {
                  loading.close();
                  this.$message({ type: 'success', message: '添加成功' });
                  this.open = false;
                  this.$refs.table.reload();
                }
              });
            }
          }
        });
      },
      /** 删除按钮操作 */
      handleDelete(row) {
        const id = row.id;
        this.$confirm('是否确认删除该指标小类？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(function() {
            const formdata = new FormData();
            formdata.append('id', id);
            formdata.append('status', 2);
            return delNorm(formdata);
          })
          .then(() => {
            this.$refs.table.reload();
            this.$message({ type: 'success', message: '删除成功' });
          })
          .catch(() => {});
      },
      // 关闭
      close() {
        this.$store.dispatch('theme/tabRemove', this.$route.fullPath).then(() => {
          this.$router.push('/ipadComputer/firstTag');
        });
      },
    },
  };
</script>

<style scoped lang="scss"></style>
